<template>
  <!-- 历史成绩 -->

  <div>
    <!-- <div>
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="关键字">
          <el-input v-model="formInline.user"
                    placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="onSubmit">查询</el-button>
          <el-button type=""
                     @click="onSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <div class="head">
      <div>历史记录</div>
      <div>
        <!-- <el-button type="primary"
                   @click="onAdd">添加试卷</el-button> -->
      </div>
    </div>
    <div style="margin-top:15px;">
      <el-table :data="tabData"
                border
                style="width: 100%">
        <el-table-column type="index"
                         align="center">
        </el-table-column>
        <el-table-column prop="teacherName"
                         label="老师姓名"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column prop="schoolName"
                         label="校区名"
                         align="center">
        </el-table-column>
        <el-table-column prop="className"
                         label="班级名"
                         align="center">
        </el-table-column>
        <el-table-column prop="examTime"
                         label="考试时间"
                         align="center">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <el-button size="mini"
                       @click="handleScore(scope.$index, scope.row)"
                       type="primary">查看成绩</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: flex-end;margin-top: 15px;">
        <el-pagination background
                       layout="prev, pager, next"
                       :total="total"
                       :page-size="pamas.pageSize"
                       @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "@/utils/datetime"
// import uploadExam from "@/components/UploadExam"
export default {
  components: {
    // uploadExam
  },
  data () {
    return {
      formInline: {},
      tabData: [],
      total: 0,
      pamas: {
        examId: "",
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created () {
    console.log(this.$route, 'd')
    let examId = localStorage.getItem('examId')||'';
    this.pamas.examId = this.$route.query.id||examId
    this.getHistoryList(this.pamas)
  },
  methods: {
    pageSizeChangeHandle (val) {
      this.pamas.pageSize = val;
      this.pamas.pageNum = 1;
      this.getHistoryList();
    },
    pageCurrentChangeHandle (val) {
      this.pamas.pageNum = val;
      this.getHistoryList();
    },
    getHistoryList (pamas) {
      this.$api.examCenter.getHistoryList(pamas).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.tabData = res.data.list
          this.total = res.data.total
        }
      })
    },
    openDialog () {
      this.dialogVisible2 = true
    },
    //onSubmit () { },
    handleScore (index, row) {
      this.$router.push({ path: "/examCenter/score", query: { id: row.examRecordId } })
      localStorage.setItem('examRecordId',row.examRecordId)//成绩记录id
    },
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-dialog__header {
  text-align: left;
}
.head {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/ExamCenter/HistoryExam.vue